import { OptionsControl } from './options.model';
import { BaseControl } from '@app/shared/dynamic-form/shared/controls/base-control';
import { TemplateRef } from '@angular/core';

interface OptionsTypeahead extends OptionsControl<string> {
  dropup: boolean;
  optionsListTemplate: TemplateRef<any>;
  typeaheadAsync: boolean;
  typeaheadGroupField: string;
  typeaheadItemTemplate: TemplateRef<any>;
  typeaheadLatinize: boolean;
  typeaheadMinLength: number;
  typeaheadOptionField: string;
  typeaheadOptionsInScrollableView: number;
  typeaheadOptionsLimit: number;
  typeaheadPhraseDelimiters: string;
  typeaheadScrollable: boolean;
  typeaheadSingleWords: boolean;
  typeaheadWaitMs: number;
  typeaheadWordDelimiters: string;
  data: any;
}

export class Typeahead extends BaseControl<string> implements OptionsTypeahead {
  controlType = 'typeahead';
  dropup: boolean;
  optionsListTemplate: TemplateRef<any>;
  typeaheadAsync: boolean;
  typeaheadGroupField: string;
  typeaheadItemTemplate: TemplateRef<any>;
  typeaheadLatinize: boolean;
  typeaheadMinLength: number;
  typeaheadOptionField: string;
  typeaheadOptionsInScrollableView: number;
  typeaheadOptionsLimit: number;
  typeaheadPhraseDelimiters: string;
  typeaheadScrollable: boolean;
  typeaheadSingleWords: boolean;
  typeaheadWaitMs: number;
  typeaheadWordDelimiters: string;
  data: any;

  constructor(options: Partial<OptionsTypeahead>) {
    super(options);
    this.dropup = !!options.dropup;
    this.optionsListTemplate = options.optionsListTemplate;
    this.typeaheadAsync = !!options.typeaheadAsync;
    this.typeaheadGroupField = options.typeaheadGroupField;
    this.typeaheadItemTemplate = options.typeaheadItemTemplate;
    this.typeaheadLatinize = options.typeaheadLatinize || true;
    this.typeaheadMinLength = options.typeaheadMinLength;
    this.typeaheadOptionField = options.typeaheadOptionField;
    this.typeaheadOptionsInScrollableView = options.typeaheadOptionsInScrollableView || 7;
    this.typeaheadOptionsLimit = options.typeaheadOptionsLimit;
    this.typeaheadPhraseDelimiters = options.typeaheadPhraseDelimiters;
    this.typeaheadScrollable = !!options.typeaheadScrollable;
    this.typeaheadSingleWords = options.typeaheadSingleWords || true;
    this.typeaheadWaitMs = options.typeaheadWaitMs;
    this.typeaheadWordDelimiters = options.typeaheadWordDelimiters;
    this.data = options.data;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dynamic-form/shared/controls/typeahead.ts